import { SxProps, InputLabel, styled as muiStyled } from '@mui/material';

export const PaintBlockReportModalStyles: Record<'modal' | 'paper', SxProps> = {
  modal: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
  },
  paper: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '27%',
  },
} as const;

export const PaintBlockReportSelectLabelStyles = muiStyled(InputLabel)(() => ({
  transform: 'translate(0, -8px)',
  fontSize: '1.2rem',
}));
